import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/categoryValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CategoryContext } from "../category";

axios.defaults.baseURL = API;

function UpdateCategory(props) {

    const {dataList, setDataList, data, ProductTypeList, setShowData} = useContext(CategoryContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.Category.toLowerCase() === params.toLowerCase() && 
                   data.ProductTypeID === values.ProductTypeID
        });
        if (results.length > 0)
            handleChange("CheckCategory", results[0].Category);
        else
            handleChange("CheckCategory", "");
    }

    const handleSelectProductType = (e) => {
        var data = ProductTypeList.filter(function (item) {
            return item.ProductType == e.target.value
        })
        if (data.length > 0) {
            handleChange("ProductType", data[0].ProductType);
            handleChange("ProductTypeID", data[0].ProductTypeID);
        } else {
            handleChange("ProductType", "");
            handleChange("ProductTypeID", "");
        }
    };

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            ProductTypeID: values.ProductTypeID,
            Category: values.Category,
        }
        await axios.put(`/updateCategory/${values.CategoryID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
            getAllCategory();
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    async function getAllCategory() {
        axios
          .get("/getAllCategory")
          .then((response) => {
            let Data = response?.data;
            setDataList(Data);
            setShowData(Data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    const ClearData = () => {
        handleChange("ProductTypeID", "");
        handleChange("ProductType", "");
        handleChange("CategoryID", "");
        handleChange("Category", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("ProductTypeID", value.ProductTypeID);
            handleChange("ProductType", value.ProductType);
            handleChange("CategoryID", value.CategoryID);
            handleChange("Category", value.Category);
            handleChange("CheckCategory", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="popUpcontent">
                <div className="popUpHeader">
                    <span>ແກ້ໄຂໝວດສິນຄ້າ</span>
                </div>
                <div className="popUpBody">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="form-group">
                                <label>ປະເພດສິນຄ້າ: </label>
                                <select name="ProductTypeID" onChange={(e) => handleSelectProductType(e)}
                                    className={`input form-control ${errors.ProductTypeID && 'is-invalid'}`}>
                                    { ProductTypeList && ProductTypeList.map((x, y) => {
                                        if (x.ProductType == values.ProductType) {
                                            return (
                                                <option key={x.ProductTypeID} value={x.ProductType} selected>
                                                    {x.ProductType}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.ProductTypeID} value={x.ProductType}>
                                                    {x.ProductType}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <span>ໜວດສິນຄ້າ</span>
                                <input className={`input form-control ${errors.Category && 'is-invalid'}`} type="text" name="Category" onChange={(e) => handleInputStatusChange(e)} value={values.Category || ''} required />
                                {errors.Category && (
                                    <p className="invalid-feedback">{errors.Category}</p>
                                )}
                            </div>
                        </div>
                        <div className="popUpfooter">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateCategory;
